<template>
    <div>
        
        <el-dialog :close-on-click-modal="false" title="BUSCAR LOCALIDADE" width="70%" :visible.sync="dialogSearchEndereco" v-on:close="closeDialog">
            <el-form label-position="top">

                <el-row :gutter="10" class="u-mt-10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item key="e-logradouro">
                            <el-input placeholder="Logradouro" v-model="filtros['logradouro']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item key="e-bairro">
                            <el-input placeholder="Bairro" v-model="filtros['bairro']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                        </el-form-item>
                    </el-col>                    
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item key="e-cidade">
                            <el-input placeholder="Cidade" v-model="filtros['cidade']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item key="e-estado">
                            <el-input placeholder="Estado" v-model="filtros['estado']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item key="e-cep">
                            <el-input placeholder="CEP" v-model="filtros['cep']" maxlength="191" @keyup.native.enter="changeFiltros"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>                 

            </el-form>
            <div class="container-table" style="height: 285px;">
                <table class="table table-striped table--hover">
                    <thead>
                        <tr>
                            <th class="hidden-mobile">Logradouro</th>
                            <th class="hidden-mobile">Bairro</th>
                            <th>Cidade</th>
                            <th class="hidden-mobile">Estado</th>
                            <th class="hidden-mobile u-text-center">CEP</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loadingEndereco">
                        <tr v-for="endereco in enderecos" :key="endereco.id" @click="selectEndereco(endereco)" class="u-pointer" style="user-select: none;">
                            <td class="hidden-mobile">{{ endereco['logradouro']['nome'] }}</td>
                            <td class="hidden-mobile">{{ endereco['bairro']['nome'] }}</td>
                            <td>{{ endereco['cidade']['nome'] }}</td>
                            <td class="hidden-mobile">{{ endereco['cidade']['estado']['nome'] }}</td>
                            <td class="hidden-mobile u-text-center">{{ endereco['cep'] }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr v-if="!loadingEndereco && enderecos.length == 0" style="border-top: 1px solid #ddd;">
                            <td colspan="100%" class="u-text-center">
                                <span>nenhum registro</span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                <div v-if="loadingEndereco" class="u-text-center u-mt-25">
                    <img src="/public/img/loading-bar.gif" />
                </div>
            </div>
            
            <span slot="footer" class="dialog-footer">
                <div class="footer-search">
                    <div>
                        <el-pagination :current-page="paginate.page" v-if="paginate.qtdEnderecos > 9" :page-size="9" :total="paginate.qtdEnderecos" @current-change="getPagePagination" background layout="prev, pager, next" small></el-pagination>
                    </div>
                    <div>
                        <el-button class="close-button" @click="closeDialog">CANCELAR</el-button>
                        <el-button type="primary" @click="getEnderecos">PESQUISAR</el-button>
                    </div>
                </div>
            </span>
        </el-dialog>
    </div>
</template>
<script>

export default {
    props: {
        open: {
            required: false,
            type: [Boolean],
            default: false
        },
    },
    data: () => ({
        paginate: {
            page: 1,
            qtdEnderecos: null,
        },
        filtros:{
            logradouro: '',
            bairro: '',
            cidade: '',
            estado: '',
            cep: ''
        },
        enderecos: [],
        dialogSearchEndereco: false,
        loadingEndereco: false        

    }),
    mounted(){ },
    methods:{
        selectEndereco(endereco){

            this.$emit('emitEndereco', endereco);
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.getEnderecos();
        },
        closeDialog(){

            this.$emit('close');

            this.filtros = {
                logradouro: '',
                bairro: '',
                cidade: '',
                cep: ''
            };

            this.enderecos = [];
        },
        getEnderecos(){

            this.filtros.logradouro = this.$removerAcentos(this.filtros.logradouro);
            this.filtros.bairro = this.$removerAcentos(this.filtros.bairro);
            this.filtros.cidade = this.$removerAcentos(this.filtros.cidade);
            this.filtros.cep = this.$removerAcentos(this.filtros.cep);
            this.loadingEndereco = true;

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/cep/getByFiltrosPaginate` + '?page=' + this.paginate.page, this.filtros, this.$store.getters.getHeaderAuth).then(response => {
                
                this.enderecos = response.data.data;
                this.paginate.qtdEnderecos = response.data.total;
                this.loadingEndereco = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.getEnderecos();
        },

    },
    watch: {
        open: {
            immediate: true,
            handler (value) {

                this.dialogSearchEndereco = value;
            }
        },
    }
}
</script>
